export class ModuleRoutingConstants {

    public static APPLICATIONS = 'applications';
    public static APPLICATIONS_MANAGE_FULL = '/applications';
    public static APPLICATIONS_ROUTER = [ModuleRoutingConstants.APPLICATIONS];

    public static WHITELIST = 'whitelist';
    public static WHITELIST_MANAGE_FULL = '/whitelist';
    public static WHITELIST_ROUTER = [ModuleRoutingConstants.WHITELIST];

    public static CARD = 'card';
    public static CARD_MANAGE_FULL = '/card';
    public static CARD_ROUTER = [ModuleRoutingConstants.CARD];

    public static HISTORY_OF_REQUESTS = 'history';
    public static HISTORY_OF_REQUESTS_FULL = '/history';
    public static HISTORY_OF_REQUESTS_ROUTER = [ModuleRoutingConstants.HISTORY_OF_REQUESTS];

    public static BANK_IDENTITY = 'bankidentity';
    public static BANK_IDENTITY_MANAGE_FULL = '/bankidentity';
    public static BANK_IDENTITY_ROUTER = [ModuleRoutingConstants.BANK_IDENTITY];

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/core/helpers/module-routing.constants.ts